/**
 * The team-lead choice, as the kit Select holds it. A team with no lead has the COO standing in, and the
 * pickers on /teams/new and /teams/:id offer that as a choice of its own. The native select they replaced
 * said it with an empty value; the kit Select (Reka) refuses an item whose value is the empty string, so
 * the COO is held as this value instead and turned back into `null` before anything is sent.
 *
 * Member ids are UUIDs, so no member can ever be mistaken for it.
 */
export const COO_ACTING_AS_LEAD = 'coo-acting-as-lead'

/** What the picker holds for a team's lead: the member, or the COO standing in when there is none. */
export function leadChoice(leadMemberId: string | null | undefined): string {
    return leadMemberId || COO_ACTING_AS_LEAD
}

/** The `leadMemberId` a picker's choice sends: the member chosen, or `null` for the COO (or no choice at all). */
export function leadMemberIdOf(choice: unknown): string | null {
    if (choice === null || choice === undefined || choice === '' || choice === COO_ACTING_AS_LEAD) {
        return null
    }
    return String(choice)
}
